module.exports = __webpack_public_path__ + "static/spark_head_with_circle_v2-dd380bdda4fab13b935fe785accb0a45.png";